module.exports = __webpack_public_path__ + "static/media/programimg3.257c1851.webp";